import React from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';

import LearnersAnalytics from 'pages/insights/containers/learnersAnalyticsContainer';
import LearnerDetails from 'pages/insights/containers/learnerDetailContainer';
import CoursesAnalytics from 'pages/insights/containers/coursesAnalyticsContainer';
import CourseDetail from 'pages/insights/containers/courseDetailContainer';

const Insights = (props) => {
  let { path } = useRouteMatch();
  return (
    <div className="insights-content-container">
      <Switch>
        <Route exact path="/panel/insights">
          <Redirect to={`${path}/learners`} />
        </Route>
        <Route exact path={`${path}/learners`}>
          <LearnersAnalytics />
        </Route>
        <Route exact path={`${path}/courses`}>
          <CoursesAnalytics />
        </Route>
        <Route exact path={`${path}/learners/learner-details/:username`}>
          <LearnerDetails />
        </Route>
        <Route exact path={`${path}/courses/course-details/:course_id`}>
          <CourseDetail />
        </Route>
      </Switch>
    </div>
  );
};

export default Insights;
